import React, {useState, useEffect} from "react";
import { AgGridReact } from "ag-grid-react";
import { getNewPortfolios } from "../../../../config/apiConfig";
import { sbaAxios } from "../../../utils/sbaAxios";

function NewPortfolio(){
    const [gridData, setGridData] = useState([
        {AccountName: 'chpo01', AccountTitle:'developer'}
    ]);

    useEffect(()=>{
        const fetchNewPortfolios = async()=>{
            try{
                const list = await sbaAxios({
                    url:getNewPortfolios
                })
                setGridData(list)
            }
            catch(e){
                setGridData(gridData)
            }
        }
        fetchNewPortfolios();
    },[])

    const columnDefs =[
        {header:"Account ID", field:"AccountId"},
        {header:"Account Name", field:"AccountName",  flex:1},
        {header:"Account Title", field:"AccountTitle", flex:1},
        {header:"Custodian Name", field:"CustodianName", flex:1}
    ]
    return(
        <>
        <div className="container-fluid mx-2">
            <div className="row justify-content-start">
                    <div class="col-lg-12 col-md-12 bg-white  rounded">
                        <div className="ag-theme-alpine" style={{ height: "70vh", width: "75%" }}> 
                                <AgGridReact columnDefs={columnDefs} rowData={gridData} defaultColDef={{resizable:true}}></AgGridReact>
                        </div>
                    </div>
            </div>
        </div>
        </>
    )
}

export default NewPortfolio;